<div class="Footer_bottom">
    <section class="pt-4" *ngIf="userDetail">
        <div class="container-fluid">
            <div class="d-flex justify-content-between align-items-center mb-3 profile-header-row">
                <h1 class="profile-page-title mb-0">My Profile</h1>
                <button class="btn text-white fs-12 edit-btn rounded-pill d-flex justify-content-center align-items-center" (click)="viewUserDetail()"  *ngIf="[1].includes(userAllDetails?.userlevel_id)">Edit Profile
                    <span class="ms-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path d="M0,0H20V20H0Z" fill="none"/>
                            <path d="M12.334,8.081l.776.776L5.464,16.5H4.688v-.776l7.646-7.646M15.372,3a.845.845,0,0,0-.591.245L13.237,4.789,16.4,7.954,17.946,6.41a.84.84,0,0,0,0-1.19L15.971,3.245a.829.829,0,0,0-.6-.245ZM12.334,5.692,3,15.026v3.165H6.165L15.5,8.857Z" transform="translate(-0.595 -0.595)" fill="#fff"/>
                        </svg>
                    </span>
                </button>
            </div>

            <ng-container *ngIf="isAdmin">
            <div class="card border-0 profile-card mb-3">
                <div class="card-body">
                    <div class="row">
                        <div class="me-4 col-md-auto position-relative">
                            <img [src]="showImage ? showImage : '../../../assets/images/user.png'" class="img-fluid profile-img border rounded-circle mb-3" alt="">
                            <div class="edit-box position-absolute d-sm-none d-flex align-items-center justify-content-center rounded-circle" (click)="viewUserDetail()">
                                <svg id="edit_black_24dp_4_" data-name="edit_black_24dp(4)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <path id="Path_8043" data-name="Path 8043" d="M0,0H20V20H0Z" fill="none"/>
                                    <path id="Path_8044" data-name="Path 8044" d="M12.334,8.081l.776.776L5.464,16.5H4.688v-.776l7.646-7.646M15.372,3a.845.845,0,0,0-.591.245L13.237,4.789,16.4,7.954,17.946,6.41a.84.84,0,0,0,0-1.19L15.971,3.245a.829.829,0,0,0-.6-.245ZM12.334,5.692,3,15.026v3.165H6.165L15.5,8.857Z" transform="translate(-0.595 -0.595)" fill="#fff"/>
                                  </svg>
                            </div>
                        </div>
                        <div class="col">
                            <div class="d-flex justify-content-between mb-2">
                                <h5 class="fs-24 fw-bold">{{userAllDetails?.name ? userAllDetails?.name : '---'}}</h5>
                            </div>

                            <div class="d-md-flex personal-imformation">
                                <div class="email-div me-md-5">
                                    <div class="fs-12 color-44">Email ID</div>
                                    <p class="fs-16 fw-500 color-44 m-0">{{userAllDetails?.email ? userAllDetails?.email : '---'}}</p>
                                </div>
                                <div class="role-div me-md-5">
                                    <div class="fs-12 color-44">Role</div>
                                    <p class="fs-16 fw-500 color-44 m-0">{{userAllDetails['role.name'] ? userAllDetails['role.name'] : '---'}}</p>
                                </div>
                                <div class="location-div me-md-5" *ngIf="[6].includes(userAllDetails?.userlevel_id)">
                                    <div class="fs-12 color-44">Country</div>
                                    <p class="fs-16 fw-500 color-44 m-0">{{userAllDetails['country.name'] ? userAllDetails['country.name'] : '---'}}</p>
                                </div>

                                <div class="location-div me-md-5" *ngIf="[6].includes(userAllDetails?.userlevel_id)">
                                    <div class="fs-12 color-44">Sector </div>
                                    <p class="fs-16 fw-500 color-44 m-0">{{userAllDetails['sector.name'] ? userAllDetails['sector.name'] : '---'}}</p>
                                </div>

                                <div class="location-div me-md-5" *ngIf="[6].includes(userAllDetails?.userlevel_id)">
                                    <div class="fs-12 color-44">Msme</div>
                                    <p class="fs-16 fw-500 color-44 m-0">{{userAllDetails['msme.name'] ? userAllDetails['msme.name'] : '---'}}</p>
                                </div>
                                <div class="location-div me-md-5" *ngIf="[6].includes(userAllDetails?.userlevel_id)">
                                    <div class="fs-12 color-44">Msme Type</div>
                                    <p class="fs-16 fw-500 color-44 m-0">{{userAllDetails['msme_classification.type'] ? userAllDetails['msme_classification.type'] : '---'}}</p>
                                </div>
                                <div class="location-div me-md-5" *ngIf="[6].includes(userAllDetails?.userlevel_id)">
                                    <div class="fs-12 color-44">Employee Count</div>
                                    <p class="fs-16 fw-500 color-44 m-0">{{userAllDetails?.employeeCount ? userAllDetails?.employeeCount : '---'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card border-0 profile-card mb-3" *ngIf="userData?.userlevel_id == 1">
                <div class="d-flex justify-content-between align-items-center border-bottom" style="padding: 1rem;">
                    <h6 class="fs-16 fw-600">User Permissions</h6>
                    <div class="px-2 position-relative d-none">
                        <img src="../../../assets/images/search-line.svg" class="img-fluid position-absolute filter-search-icon" alt="">
                        <input type="search" placeholder="Search" class="form-control filter-search">
                    </div>
                </div>
                <div class="card-body py-0">
                    <div class="row">
                        <div class="col-sm-auto" style="max-height: 70vh; overflow: scroll;">
                            <ul class="nav nav-pills nav-fill flex-column me-4" style="padding: 1rem 0;">
                                <ng-container *ngFor="let item of permissionAllowedModule; let index=index">
                                    <li class="nav-item mb-2 pointer">
                                        <a class="nav-link" [ngClass]="{'active' : index==currentIndex}" (click)="changeTabs($event,index)">{{item?.label ? item?.label : '---'}}</a>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>

                        <div class="col border-start col-border p-0">

                            <h6 class="fs-16 fw-600 m-0 border-bottom" style="color: #141414; padding: 1rem;">{{getInitialModulePermission.label}}</h6>
                            <div style="padding: 1rem;">
                                <ng-container *ngFor="let item of getInitialModulePermission.authentication">
                                    <div class="d-inline-block rounded-pill mb-2 me-2" *ngIf="item?.isAction">
                                        <div class="d-flex align-items-center justify-content-center px-3 rounded-pill fs-14 fw-500 topic-name">{{item?.label ?  item?.label : '---'}}</div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </ng-container>

            <ng-container *ngIf="!isAdmin">
            <div class="card border-0 profile-card mb-3 non-admin-profile-card">
                <div class="profile-teal-banner d-flex align-items-center">
                    <div class="profile-company-icon rounded me-3">
                        <img src="assets/dashboardMedia/building-fill.svg" alt="" class="img-fluid" onerror="this.style.display='none'">
                    </div>
                    <div>
                        <h4 class="text-white fw-bold mb-0">{{ profileMsmeName }}</h4>
                        <p class="text-white mb-0 opacity-90">{{ profileSectorName }}</p>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <div class="fs-12 text-muted">Name</div>
                            <p class="fs-16 fw-600 mb-0">{{ userAllDetails?.name || '---' }}</p>
                        </div>
                        <div class="col-md-6 mb-3">
                            <div class="fs-12 text-muted">Registered Date</div>
                            <p class="fs-16 fw-600 mb-0">{{ (userAllDetails?.createdAt | date:'dd/MM/yyyy') || '---' }}</p>
                        </div>
                        <div class="col-md-6 mb-3">
                            <div class="fs-12 text-muted">Company Email</div>
                            <p class="fs-16 fw-600 mb-0">{{ userAllDetails?.email || '---' }}</p>
                        </div>
                        <div class="col-md-6 mb-3">
                            <div class="fs-12 text-muted">Enterprise Type</div>
                            <p class="fs-16 fw-600 mb-0">{{ profileMsmeClassificationType }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card border-0 profile-card mb-3">
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-3" *ngIf="!showRequestChangeForm">
                        <h6 class="fs-16 fw-600 mb-0 d-flex align-items-center">
                            <svg class="me-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style="color: #00625F;"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>
                            Number of Employees
                        </h6>
                        <button type="button" class="btn btn-outline-teal rounded-pill" (click)="openRequestChangeForm()">
                            <span class="me-1">Request Change</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
                        </button>
                    </div>

                    <div *ngIf="!showRequestChangeForm">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <div class="fs-12 text-muted">Current Employees</div>
                                <p class="fs-28 fw-bold mb-0">{{ profileEmployeeCount }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <div class="fs-12 text-muted">Enterprise Classification</div>
                                <span class="badge enterprise-badge">{{ profileEnterpriseBadge }}</span>
                            </div>
                        </div>
                    </div>

                    <form [formGroup]="requestChangeForm" *ngIf="showRequestChangeForm">
                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label class="fs-12 text-muted">Current Number of Employees</label>
                                <input type="text" class="form-control" [value]="profileEmployeeCountOrEmpty" readonly>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>New Number of Employees *</mat-label>
                                    <input matInput type="number" formControlName="newEmployeeCount" min="1" [max]="maxEmployeeCount" (keypress)="numberOnly($event)">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="d-flex gap-2">
                            <button type="button" class="btn btn-teal rounded-pill text-white" (click)="submitRequestChange()" [disabled]="requestChangeForm.invalid">Submit Change Request</button>
                            <button type="button" class="btn btn-outline-secondary rounded-pill" (click)="cancelRequestChange()">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
            </ng-container>
        </div>
    </section>

    <section *ngIf="!userDetail">
        <div class="container-fluid">
            <div class="d-flex align-items-center">
                <svg class="me-2 pointer" id="keyboard_backspace_black_24dp_3_" data-name="keyboard_backspace_black_24dp(3)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" (click)="viewUserDetail()">
                    <path id="Path_7892" data-name="Path 7892" d="M0,0H24V24H0Z" fill="none"/>
                    <path id="Path_7893" data-name="Path 7893" d="M21,11H6.83l3.58-3.59L9,6,3,12l6,6,1.41-1.41L6.83,13H21Z" fill="black"/>
                  </svg>

                <nav aria-label="breadcrumb" class="my-3">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item fs-18 fw-400 pointer profile-tab">My Profile </li>
                      <li class="breadcrumb-item fs-18 fw-600 pointer active-breadcrumb active">{{userAllDetails?.name ? userAllDetails?.name : '---'}}</li>
                    </ol>
                  </nav>
            </div>

            <form [formGroup]="userFormDetails">
                <div class="card border-0  mb-3 profile-card-two">
                    <div class="card-body pt-sm-5">
                        <div class="row">
                            <div class="col-md-auto">
                                <div class="position-relative">
                                    <div class="row mb-3">
                                        <div class="">
                                            <img src="{{showImage ?  showImage : '../../../assets/images/userLarge-img.png'}}" class="img-fluid mb-3 border user-img rounded-circle"/>
                                            <img src="../../../assets/images/camera-icon.svg" class="img-fluid position-absolute cameraIcon pointer" alt="" (click)="imageInputClickHandler($event)">
                                        </div>


                                        <div class="col-sm-12">
                                            <input type="file" #fileicon id="form-icon-input" (change)="imageInputChangeHandler($event)"
                                                hidden placeholder="Choose File icon" accept=".png,.jpg,.jpeg" style="display: none">
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="col">
                                <div class="row">
                                    <div class="col-md-4">
                                        <mat-form-field appearance="outline" class="example-full-width w-100 p-0 mb-1">
                                            <mat-label>Name *</mat-label>
                                            <input matInput type="text" formControlName="userName" placeholder="Enter Name" [ngClass]="{'is-invalid':userFormDetails.get('userName')?.touched && userFormDetails.get('userName')?.invalid}" appAlphabatesOnly>
                                        </mat-form-field>
                                        <span class="invalid-feedback" *ngIf="(userFormDetails.get('userName')?.touched  || userFormDetails.get('userName')?.dirty) && userFormDetails.get('userName')?.invalid">
                                            Name is required *.
                                        </span>
                                    </div>
                                    <div class="col-md-4">
                                        <mat-form-field appearance="outline" class="example-full-width w-100 p-0 mb-1">
                                            <mat-label>Email *</mat-label>
                                            <input matInput type="email" formControlName="email" [ngClass]="{'is-invalid':userFormDetails.get('email')?.touched && userFormDetails.get('email')?.invalid}" placeholder="example@gmail.com">
                                        </mat-form-field>
                                        <mat-error class="invalid-feedback mx-3 mb-0" *ngIf="userFormDetails.get('email')?.touched && userFormDetails.get('email')?.invalid">
                                            <ng-container *ngIf="userFormDetails.get('email')?.errors?.required">
                                                Email is required *.
                                            </ng-container>
                                            <ng-container *ngIf="userFormDetails.get('email')?.errors?.email && !userFormDetails.get('email')?.errors?.required">
                                                Please enter a valid email.
                                            </ng-container>
                                        </mat-error>
                                    </div>
                                    <div class="col-md-4 row" *ngIf="showCountryDropdown">
                                        <mat-form-field appearance="outline" class="example-full-width col-md-12 p-0 mb-1">
                                            <mat-label>Country Name *</mat-label>
                                            <mat-select formControlName="countryName" [ngClass]="{'is-invalid':userFormDetails.get('countryName')?.touched && userFormDetails.get('countryName')?.invalid}"  [disabled]="userFormDetails.value.country?.id">
                                                <mat-select-trigger *ngIf="userFormDetails?.value?.countryName">
                                                    <img [src]="userFormDetails.value?.countryName?.country_icons " alt="Image" class="option-image">
                                                    <span>{{userFormDetails.value?.countryName?.name}}</span>
                                                </mat-select-trigger>
                                                <mat-option *ngFor="let country of countrys" [value]="country">
                                                    <img [src]="country?.country_icons" alt="Image" class="option-image">
                                                    {{country?.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-error class="invalid-feedback" *ngIf="(userFormDetails.get('countryName')?.touched  || userFormDetails.get('countryName')?.dirty) && userFormDetails.get('countryName')?.invalid">
                                            Country Name is required *.
                                        </mat-error>
                                    </div>
                                    <div class="col-md-4">
                                        <mat-form-field appearance="outline" class="w-100 p-0 mb-1">
                                            <mat-label>User Role *</mat-label>
                                            <mat-select
                                                formControlName="userRole"
                                                placeholder="Select User Role"
                                                [ngClass]="{'is-invalid':userFormDetails.get('userRole')?.touched && userFormDetails.get('userRole')?.invalid}"
                                                #userRole
                                                (keydown)="preventKeyboardInput($event)"
                                                [disabled]="true"
                                            >
                                                <ng-container *ngFor="let userRole of userRoles">
                                                    <mat-option [value]="userRole">
                                                        {{userRole?.name}}
                                                    </mat-option>
                                                </ng-container>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-error class="invalid-feedback" *ngIf="(userFormDetails.get('userRole')?.touched  || userFormDetails.get('userRole')?.dirty) && userFormDetails.get('userRole')?.invalid">
                                            User Role is required *.
                                        </mat-error>
                                    </div>

                                    <div class="col-md-4" *ngIf="userFormDetails.value.userRole?.id !== ADMIN_ROLE">
                                        <mat-form-field appearance="outline" class="w-100 p-0 mb-1">
                                            <mat-label>Sector Name *</mat-label>
                                            <mat-select formControlName="sectorName" [ngClass]="{'is-invalid':userFormDetails.get('sectorName')?.touched && userFormDetails.get('sectorName')?.invalid}" (selectionChange)="sectorChangeHandler($event)" [disabled]="!sectorNames?.length || userFormDetails.value.userRole?.id !== ADMIN_ROLE">
                                                <mat-option *ngFor="let sectorName of sectorNames" [value]="sectorName">
                                                    {{sectorName?.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-error class="invalid-feedback" *ngIf="(userFormDetails.get('sectorName')?.touched  || userFormDetails.get('sectorName')?.dirty) && userFormDetails.get('sectorName')?.invalid">
                                            Sector Name is required *.
                                        </mat-error>
                                    </div>
                                    <div class="col-md-4" *ngIf="userFormDetails.value.userRole?.id !== ADMIN_ROLE">
                                        <mat-form-field appearance="outline" class="w-100 p-0 mb-1">
                                            <mat-label>Msme Name *</mat-label>
                                            <mat-select formControlName="msmeName" [ngClass]="{'is-invalid':userFormDetails.get('msmeName')?.touched && userFormDetails.get('msmeName')?.invalid}" [disabled]="!msmeNames?.length || userFormDetails.value.userRole?.id !== ADMIN_ROLE">
                                                <mat-option *ngFor="let msmeName of msmeNames" [value]="msmeName">
                                                    {{msmeName?.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-error class="invalid-feedback" *ngIf="(userFormDetails.get('msmeName')?.touched  || userFormDetails.get('msmeName')?.dirty) && userFormDetails.get('msmeName')?.invalid">
                                            Msme Name is required *.
                                        </mat-error>
                                    </div>
                                    <div class="col-md-4" *ngIf="userFormDetails.value.userRole?.id !== ADMIN_ROLE">
                                        <mat-form-field appearance="outline" class="example-full-width col-md-12 p-0 mb-1">
                                            <mat-label>Employee Count</mat-label>
                                            <input matInput type="text" placeholder="Enter Employee Count" min="1" max="{{maxEmployeeCount}}" (blur)="onEmployeeCountBlur()" formControlName="employeeCount" [ngClass]="{'is-invalid':userFormDetails.get('employeeCount')?.touched && userFormDetails.get('employeeCount')?.invalid}" (keypress)="numberOnly($event)">
                                        </mat-form-field>
                                        <span class="invalid-feedback" *ngIf="(userFormDetails.get('employeeCount')?.touched  || userFormDetails.get('employeeCount')?.dirty) && userFormDetails.get('employeeCount')?.invalid">
                                            Employee Count is required *.
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="text-end mt-3">
                                <button class="btn update-btn rounded-pill text-white mb-4" (click)="updateUser()" [disabled]="userFormDetails.invalid">Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    </section>
</div>